import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import { installGlobalErrorReporting } from './shell/error-report.js';
import { RegionErrorBoundary } from './shell/RegionErrorBoundary.js';
import { installPopGate } from './ui/unsaved-changes.js';
import './styles/tokens.css';
import './styles/base.css';
import './styles/shell.css';
import './styles/components.css';

const container = document.getElementById('root');
if (!container) throw new Error('Calis: #root is missing from index.html');

// Why: app-baseline 05-client §5.1 — runtime errors no boundary sees (an event handler, a timer, a rejected promise
// nobody awaited) are still reported under a reference (§5.2), as a render error is by its boundary.
installGlobalErrorReporting(window);

// Why before the app renders (03-components §3.3; Phase 1c finding G9): an editor holding unsaved changes asks before
// Back or Forward leaves its page, and only a popstate listener added before the router's own can hold the pop.
installPopGate(window);

// Why a root boundary (05-client §5.1, "placed so that a failure in one region does not take the whole application
// with it"): the shells' boundaries wrap only the routed page, so a render error in the chrome — the account menu, the
// rail, MeProvider, the toast viewport — unmounted the tree to a white page. This one is the last catch: bare, since it
// stands outside the router and every provider, offering a retry and a full navigation to the overview. Conformity
// finding G1; the owner's brief of 2026-10-05, group B.
createRoot(container).render(
  <StrictMode>
    <RegionErrorBoundary region="Calis" bare>
      <App />
    </RegionErrorBoundary>
  </StrictMode>,
);
